import { Button, Icon, ScrollArea } from "@Rolec-Services/rolec-ui";
import { TFunction } from "i18next";
import { CompareData } from "../data";
import { Headers } from "./header";

export type CompareProps = {
  t: TFunction;
  buttons: { onClick: () => void }[];
};

export const boxClassName =
  "bg-grey-200 text-center text-xs px-1 py-1 flex items-center justify-center";

export function Compare({ t, buttons }: CompareProps) {
  return (
    <div className="flex flex-col gap-4">
      <Headers t={t} />
      <Table t={t} />
      <div className="flex justify-between w-full gap-2 ">
        {buttons.map((button, index) =>
          index === 0 ? (
            <div
              key={`tier-header-placeholder-${index}`}
              className="flex flex-row justify-center w-full"
            />
          ) : (
            <div
              key={`tier-button-${index}`}
              className="flex flex-row justify-center w-full"
            >
              <Button
                type="button"
                size="sm"
                className="h-8"
                onClick={button.onClick}
              >
                {t("Confirm")}
                <Icon icon="ArrowRight" />
              </Button>
            </div>
          )
        )}
      </div>
    </div>
  );
}

function Table({ t }: { t: TFunction }) {
  const info = CompareData(t);
  return (
    <div className="flex flex-col gap-2 w-full">
      <ScrollArea className="flex flex-col gap-2 w-full lg:max-h-[480px] overflow-y-auto">
        <div className="grid grid-cols-3 w-full justify-between gap-2">
          {info.map((node, index) => (
            <div className={boxClassName} key={index} children={node} />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}
